import { ref, Ref, defineComponent, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from '@/axios'
import { host } from '@/const'
import { linkRightMenu } from '@/vars'
import Preloader from '@/components/preloader/preloader.vue'
import './style.sass'

export default defineComponent({
  setup () {
    const route = useRoute()

    const menuElement = ref(null) as unknown as Ref<HTMLElement>
    const isOpenMenu = ref(false)

    const handleClickOutside = (event: Event) => {
      isOpenMenu.value = (event.target as HTMLInputElement) === menuElement.value || ('mobileMenu' in (event.target as HTMLInputElement).dataset)
    }
    onMounted(() => {
      document.addEventListener('mousedown', handleClickOutside)
    })
    onUnmounted(() => {
      document.removeEventListener('mousedown', handleClickOutside)
    })

    const preloader = ref(false)
    const formSend = ref<boolean>(false)
    const formMessage = ref<string>('')

    let filterLinkRightMenu: Array<unknown> = []

    filterLinkRightMenu = linkRightMenu.filter((item: any) => {
      const itemId = item.places.indexOf(route.name)
      return itemId !== -1
    })

    const logout = async () => {
      preloader.value = true
      try {
        const response = (await axios.post(`${host}/api/v1/clients/logout`, {}))
        if (response.data) {
          delete (localStorage.AuthClient)
          location.href = '/'
          formSend.value = response.data.message
        }
      } catch (error: any) {
        preloader.value = false
        formMessage.value = 'Произошла ошибка, попробуйте позже'
      }
    }

    return () => {
      return (
        <div class={`sorting-element-dropdown-modal ${isOpenMenu.value ? 'element-dropdown-collapse-modal' : ''}`}>
          <div
            ref={menuElement}
            class={`dropdown-modal-value ${isOpenMenu.value ? 'value-collapse' : ''}`}>
            <h3>Меню</h3>
            {
              filterLinkRightMenu.map((item: any, index: any) => (
                <div>
                  <router-link
                    to={item.link}
                    class={`sorting-select-element-dropdown-value 
                      ${item.aliases.indexOf(route.name) !== -1 ? 'dropdown-value-selected' : ''}
                    `}>
                    {item.name}
                  </router-link>
                  {index === 1
                    ? (<a href="https://cable.ru/products/" class="sorting-select-element-dropdown-value">Продукция</a>)
                    : null
                  }
                </div>
              ))
            }
            {preloader.value
              ? (
                <Preloader style="position: relative; margin: 28px auto;"/>
              )
              : (
                <a onClick={logout} class='sorting-select-element-dropdown-value'>Выйти из профиля</a>
              )
            }
          </div>
        </div>
      )
    }
  }
})